import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faCheckCircle, faSuitcase } from '@fortawesome/free-solid-svg-icons';
import { faHeart, faUser } from '@fortawesome/free-regular-svg-icons';
import { ListedCar } from 'src/app/core/models/car.model';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { AppConstants, ONBOARDING_STEPS } from 'src/app/core/constants';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'src/app/core/models/user.model';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { DailogReplaceCarComponent } from '../dailog-replace-car/dailog-replace-car.component';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { get } from 'lodash';

@Component({
  selector: 'app-car-info',
  templateUrl: './car-info.component.html',
  styleUrls: ['./car-info.component.scss',],
})
export class CarInfoComponent {

  faCheckCircle = faCheckCircle;
  faHeart = faHeart;
  faUser = faUser;
  faSuitcase = faSuitcase;

  bsModalRef?: BsModalRef;
  isPumPumPum: boolean = environment.source.toLowerCase() === 'pumpumpum';

  selectedMileage: number = AppConstants.ZERO;
  selectedTenure: number = AppConstants.ZERO;

  @Input() carDetails?: ListedCar;
  @Input() showViewDetails: boolean = true;

  @Output() mileage = new EventEmitter<number>();
  @Output() tenure = new EventEmitter<number>();

  constructor(
    private _toastr: ToastrService,
    private _authService: AuthService,
    private _router: Router,
    private _modalService: BsModalService,
    private _subscriptionService: SubscriptionService,
    private _$gaService: GoogleAnalyticsService
  ) { }

  viewDetails() {
    this._router.navigateByUrl(`cars/details/${this.carDetails?.slug}-${this.carDetails?._id}`);
  }

  tenureChanged(tenure: number) {
    this.selectedTenure = tenure;
    this.tenure.emit(tenure);
  }

  mileageChanged(mileage: number) {
    this.selectedMileage = mileage;
    this.mileage.emit(mileage);
  }

  requestToSubscribe() {
    if (!this.carDetails) return;
    const selectedCarInfo = {
      selectedVehicle: this.carDetails._id,
      tenure: this.selectedTenure,
      mileage: this.selectedMileage,
    };
    if (!this._authService.getToken()) {
      this._$gaService.event('request_to_subscribe', selectedCarInfo?.selectedVehicle);
      this._subscriptionService.setSelectedCar(selectedCarInfo);
      this._router.navigateByUrl('auth');
      return;
    }

    this._subscriptionService.getSubscription().subscribe({
      next: (response: any) => {
        if (response.subscriptions && response.subscriptions.length) {
          // eslint-disable-next-line no-magic-numbers
          const subscription = response.subscriptions.find((sub: Subscription) => ['LEAD', 'PROSPECT',].includes(sub.status));

          if (!subscription) {
            this.createSubscription(selectedCarInfo);
            return;
          }

          if (!subscription || !subscription.canChangeVehicle) {
            this._toastr.error('Car change not allowed');
            return;
          }

          if (
            (subscription.selectedVehicle != selectedCarInfo.selectedVehicle) ||
            (subscription.tenure != selectedCarInfo.tenure) ||
            (subscription.mileage != selectedCarInfo.mileage)
          ) {
            this.confirmReplaceCar(subscription, selectedCarInfo);
            return;
          }

          this._router.navigateByUrl('dashboard');
        } else {
          this.createSubscription(selectedCarInfo);
        }
      },
    });
  }

  confirmReplaceCar(subscription: Subscription, selectedCarInfo: any) {
    const initialState: ModalOptions = {
      initialState: {
        subscription,
        selectedCarInfo,
      },
      class: 'modal-dialog-centered',
      ignoreBackdropClick: false,
    };
    this.bsModalRef = this._modalService.show(DailogReplaceCarComponent, initialState);
    this.bsModalRef.content.onClose.subscribe((yes: boolean) => {
      if (yes) this.changeSubscriptionCar(subscription._id, selectedCarInfo);
    });
  }

  changeSubscriptionCar(subscriptionId: string, selectedCarInfo: any) {
    this._subscriptionService.changeSubscriptionCar(subscriptionId, selectedCarInfo).subscribe({
      next: (_data) => {
        this._router.navigateByUrl('dashboard');
      },
      error: (error) => {
        const { message, } = error?.error;
        this._toastr.error(message);
      },
    });
  }

  createSubscription(selectedCarInfo: any) {
    this._subscriptionService.createSubscription(selectedCarInfo).subscribe({
      next: (data) => {
        this._navigateNext(data._id);
      },
      error: (error) => {
        const { message, } = error?.error;
        this._toastr.error(message);
      },
    });
  }

  _navigateNext(subscriptionId: string) {
    this._subscriptionService.getSubscriptionJourney(subscriptionId).subscribe({
      next: (steps) => {
        const nextStep = steps?.stepsRequired.sort((a: any, b: any) => a.order - b.order).find((s: any) => s.status != 'SUBMITTED');
        if (nextStep) this._router.navigateByUrl(`kyc/${subscriptionId}/${get(ONBOARDING_STEPS, nextStep.name)}`);
        else this._router.navigateByUrl('dashboard');
      },
    });
  }

}
